import { createSlice } from '@reduxjs/toolkit';

const customerSlice = createSlice({
  name: 'customer',
  initialState: {
    list: [],
  },
  reducers: {
    setCustomer: (state, action) => {
      state.list = action.payload;
    },
    addCustomer: (state, action) => {
      state.list.push(action.payload);
    },
    updateCustomer: (state, action) => {
      const index = state.list.findIndex(customer => customer._id === action.payload._id);
      if (index !== -1) {
        state.list[index] = action.payload;
      }
    },
 
        deleteCustomer: (state, action) => {
        state.list = state.list.filter(customer => customer._id !== action.payload);
        }

  },
});

export const {
  setCustomer,
  addCustomer,
  updateCustomer,
  deleteCustomer
} = customerSlice.actions;

export default customerSlice.reducer;
